import React, { useEffect, useState } from 'react';
import authedFetch from '../../lib/authedFetch';
import { Button } from '../../components/ui/button';
import { Loader2, Save, Layers } from 'lucide-react';
import { TextField, SelectField } from './FieldKit';

const API = process.env.REACT_APP_BACKEND_URL;

export default function StepVerticalScale({ step, state, onSave, saving, shareToken }) {
  const [draft, setDraft] = useState(state.answers || {});
  const [profiles, setProfiles] = useState([]);
  useEffect(() => { setDraft(state.answers || {}); }, [state]);
  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v }));

  useEffect(() => {
    if (shareToken) return; // public mode can't fetch the library
    (async () => {
      try {
        const r = await authedFetch(`${API}/api/industry-profiles`);
        if (r.ok) {
          const d = await r.json();
          setProfiles(d.profiles || []);
        }
      } catch { /* noop */ }
    })();
  }, [shareToken]);

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-5 space-y-5" data-testid="onboarding-step-vertical-scale">
      <div className="space-y-2">
        <div className="text-xs font-medium text-slate-700">
          Industry profile <span className="text-rose-500">*</span>
        </div>
        {profiles.length === 0 ? (
          <p className="text-xs text-slate-500">No published industry profiles available.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2" data-testid="onb-industry-grid">
            {profiles.map((p) => {
              const active = draft.industry_id === p.id;
              return (
                <button
                  type="button"
                  key={p.id}
                  onClick={() => set('industry_id', p.id)}
                  className={`text-left rounded-lg border p-2.5 transition-all ${
                    active
                      ? 'border-indigo-400 bg-indigo-50 ring-1 ring-indigo-300'
                      : 'border-slate-200 bg-white hover:border-indigo-300'
                  }`}
                  data-testid={`onb-industry-pick-${p.id}`}
                >
                  <Layers className={`h-4 w-4 mb-1 ${active ? 'text-indigo-600' : 'text-slate-400'}`} />
                  <div className={`text-xs font-semibold ${active ? 'text-indigo-900' : 'text-slate-800'}`}>
                    {p.name}
                  </div>
                  <div className="text-[10px] text-slate-500 mt-0.5 line-clamp-2">
                    {p.short_label || p.description}
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {step.fields.filter((f) => f.key !== 'industry_id').map((f) => (
          f.type === 'enum'
            ? <SelectField key={f.key} field={f} value={draft[f.key]} onChange={set} testIdPrefix="onb-vertical" />
            : <TextField key={f.key} field={f} value={draft[f.key]} onChange={set} testIdPrefix="onb-vertical" />
        ))}
      </div>
      <div className="flex justify-end pt-2">
        <Button onClick={() => onSave(draft)} disabled={saving} data-testid="onb-vertical-save">
          {saving ? <Loader2 className="h-3.5 w-3.5 mr-2 animate-spin" /> : <Save className="h-3.5 w-3.5 mr-2" />}
          Save & continue
        </Button>
      </div>
    </div>
  );
}
